export default __webpack_public_path__ + "static/default-share-image-48f9fae2c00b69155053c6427c0260e5.jpeg";